__turbopack_context__.v({
  "className": "u7qrYq_className",
  "variable": "u7qrYq_variable",
});
